export const getCurrentUserTz = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;
